import { SubmitButton } from 'components/common/buttons/SubmitButton';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { fetchInterpreters } from 'slices/interpreterSlice';
import { selectCustomStyles } from './Select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { fetchVendors } from 'slices/vendorSlice';
import { CheckinCheckout } from 'components/ScheduleForm';
import { CheckinDateTimeInputs } from 'components/ScheduleForm';
import { CheckoutDateTimeInputs } from 'components/ScheduleForm';
import { CommentsAndNotes } from 'components/ScheduleForm';

function SelectInterpreterModal({
    isOpen,
    onClose,
    onConfirm,
    item,
    loader,
    appointmentId,
}) {

    const dispatch = useDispatch();
    const methods = useForm();
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors } = methods



    useEffect(() => {

        methods.reset({ cancel_reason: '' })

    }, [isOpen])

    useEffect(() => {
        setValue("vendor_id", item?.appointment_assign?.vendor_id || "");
        setValue("interpreter_id", item?.appointment_assign?.interpreter_id || "");
        setValue("checkin_date", item?.appointment_assign?.checkin_date || "");
        setValue("checkin_time", item?.appointment_assign?.checkin_time || "");
        setValue("checkout_date", item?.appointment_assign?.checkout_date || "");
        setValue("checkout_time", item?.appointment_assign?.checkout_time || "");
        setValue("comments", item?.appointment_assign?.comments || "Other");
        setValue("notes", item?.appointment_assign?.notes || "");
    }, [item, isOpen])

    const isVendor = useMemo(() => {
        return watch('vendor_id') ? true : false
    }, [watch('vendor_id'), isOpen])

    const isInterpreter = useMemo(() => {
        return watch('interpreter_id') ? true : false
    }, [watch('interpreter_id'), isOpen])

    // #region vendordropdown 
    const [filterVendor, setFilterVendors] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        if (item?.vendor?.name && item?.vendor?.id) {
            setFilterVendors({
                label: item?.vendor?.name || "",
                value: item?.vendor?.id || ""
            })
        } else {
            setFilterVendors(null)
        }
    }, [item?.vendor])

    const filteredVendorLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchVendors(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    // #region Interpreter Dropdown 
    const [filterInterpreters, setFilterInterpreters] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        if (item?.interpreter?.first_name && item?.interpreter?.id) {
            setFilterInterpreters({
                label: item?.interpreter?.first_name || "",
                value: item?.interpreter?.id || ""
            })
        } else {
            setFilterInterpreters(null)
        }
    }, [item?.interpreter])

    const filteredInterpretersLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchInterpreters(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.first_name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion


    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <FormProvider {...methods}>
                    <form action="" onSubmit={handleSubmit((data) => onConfirm(data, "assign"))}>
                        <ModalHeader className='header_modal align-items-center'>
                            <h5 className="modal-title_u">Assign</h5>
                        </ModalHeader>
                        <ModalBody className='modal_form_body'>
                            <div className='step_cards step_1'>
                                <h2>Assign</h2>
                                {/* VENDOR SELECT */}
                                <div className="row-primary">
                                    <h2>Vendor</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="vendor_id"
                                            control={control}
                                            render={({ field }) =>
                                                <div style={{ width: "100%" }}>
                                                    <AsyncPaginate
                                                        menuPlacement='auto'
                                                        styles={{
                                                            ...selectCustomStyles,
                                                        }}
                                                        isDisabled={isInterpreter} // Keep this for UI behavior
                                                        value={filterVendor}
                                                        loadOptions={filteredVendorLoadOptions}
                                                        isClearable
                                                        escapeClearsValue
                                                        onChange={(obj) => {
                                                            if (obj?.value) {
                                                                setFilterVendors(obj);
                                                                field.onChange(obj.value);
                                                            } else {
                                                                setFilterVendors(null);
                                                                field.onChange(null);
                                                            }
                                                        }}
                                                        additional={{
                                                            page: item?.state?.id ? 2 : 1,
                                                        }}
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                </div>

                                {/* INTERPRETER SELECT */}
                                {/* <div className="row-primary">
                                    <h2>Interpreter</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="interpreter_id"
                                            control={control}
                                            render={({ field }) =>
                                                <div style={{ width: "100%" }}>
                                                    <AsyncPaginate
                                                        menuPlacement='auto'
                                                        styles={{
                                                            ...selectCustomStyles,
                                                        }}
                                                        isDisabled={isVendor}
                                                        value={filterInterpreters}
                                                        loadOptions={filteredInterpretersLoadOptions}
                                                        isClearable
                                                        escapeClearsValue
                                                        onChange={(obj) => {
                                                            if (obj?.value) {
                                                                setFilterInterpreters(obj)
                                                                field.onChange(obj.value);
                                                            }
                                                            else {
                                                                setFilterInterpreters(null)
                                                                field.onChange(null);
                                                            }
                                                        }}
                                                        additional={{
                                                            page: item?.state?.id ? 2 : 1,
                                                        }}
                                                    />
                                                </div>
                                            }
                                        />
                                    </div>
                                </div> */}
                                {
                                    watch("interpreter_id") &&
                                    <CheckinCheckout apptAssign={item?.appointment_assign} />
                                }
                                {
                                    ((watch("available_status") && watch("interpreter_id") && item?.appointment_assign?.interpreter_id)) && (
                                        <>
                                            <CheckinDateTimeInputs />
                                            <CheckoutDateTimeInputs />
                                            <CommentsAndNotes />
                                        </>
                                    )
                                }
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <SubmitButton btnText="Submit" />
                            <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                        </ModalFooter>
                    </form>
                </FormProvider>
            </Modal>
        </>
    );
}

export default SelectInterpreterModal;